import { connect } from 'react-redux';

import { ProductLineName } from '@/components/modals/SubmitOrder/types';
import { ProposalWithBom } from '@/controllers/Activity';
import { selectProductLineName } from '@/store/reducers/products/selectors';
import { selectProposal } from '@/store/reducers/proposals/selectors';
import { AppState } from '@/types';

import { OrderDetails as Component } from './OrderDetails';

const mapStateToProps = (state: AppState) => ({
  productLineName: selectProductLineName(state) as ProductLineName,
  proposal: selectProposal(state) as ProposalWithBom,
});

export const OrderDetails = connect(mapStateToProps)(Component);
